import React, { useState, useRef, useEffect } from 'react';
import "./Subscriptions.css"

import vl from "../../images/vl.png";
import pl from "../../images/pl.png";
import bl from "../../images/bl.png";
import yl from "../../images/yl.png";

import loadimg from "../../images/loader_wish.gif";

import axios from 'axios';
import { END_URL, IMG_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SubscriptionModal from "./SubscriptionModal";

function Subscriptions({ url,sub_id,Subcription, onLoginChange, userdetail, subs ,insufficientPayment,reason,free_popup,force_to_disable=true}) {
    
    console.log('userdetail',userdetail);

    const [ButtonLoad, setButtonLoad] = useState(null);

    const [FreeTestAttend,setFreeTestAttend] = useState(Subcription?.user_attent_free_test);

    const [FreeTestSub,setFreeTestSub] = useState(Subcription?.user_have_free_test_sub);

    useEffect(() => {
        setFreeTestAttend(Subcription?.user_attent_free_test);
        setFreeTestSub(Subcription?.user_have_free_test_sub);
        setFreeTest(Subcription?.test);
    }, [Subcription]);

    const [paymentupdate, setpaymentupdate] = useState(!!(url && sub_id));

    const [checkingStatus, setCheckingStatus] = useState(false);

   useEffect(() => {

        if (!sub_id) return;

        setCheckingStatus(true);

        const interval = setInterval(async () => {
            try {

            const res = await axios.get(

                `${END_URL}/payment-status/${sub_id}`,
                {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                }
            );

            if (res.data.status === "succeeded") {

                clearInterval(interval);

                setCheckingStatus(false);
                setShowInsufficientPopup(false);

                window.history.replaceState({}, "", window.location.pathname);

                if (url) {

                    window.location.href = url;
                }
            }
            } catch (err) {

            console.error("Payment status check failed", err);
            }
        }, 3000); 

        return () => clearInterval(interval);

    }, [sub_id, url]);

    const [FreeTest,setFreeTest] = useState(Subcription?.test);

    const [showPopup,setshowPopup] = useState(false);

    const [contentType,setcontentType] = useState("");

    const [DilemmaPopup,setDilemmaPopup] = useState(false);

    const [showFreeSub,setshowFreeSub] = useState(false);

    const subS = true;

    const [subscriptionmodal, setSubscriptionModal] = useState(null);

    const [ShowModal, setShowModal] = useState(false);

    const [showInsufficientPopup, setShowInsufficientPopup] = useState(false);

    const reasonMessages = {
        insufficient: "Your card has insufficient funds.",
        expired: "Your card has expired.",
        declined: "Your card was declined.",
        fraud: "Payment blocked due to fraud suspicion.",
        refused: "Your bank refused the payment.",
        lost_stolen: "This card is reported lost or stolen.",
        invalid_card: "Invalid card number.",
        invalid_account: "The card account is invalid.",
        cvv_failed: "Invalid CVV number.",
    };

    const [reasonMessage, setReasonMessage] = useState("");

    useEffect(() => {

        if (reason && reasonMessages[reason]) {

            setReasonMessage(reasonMessages[reason]);
        } else {
            setReasonMessage(""); 
        }
    }, [reason]);

    useEffect(() => {
        if (insufficientPayment) {
            setShowInsufficientPopup(true);
        }
    }, [insufficientPayment]);


    const [showCouponPopup, setShowCouponPopup] = useState(null);
    const [couponCode, setCouponCode] = useState("");
    const [couponError, setCouponError] = useState("");
    const [SubTypeError,setSubTypeError] = useState("");
    const [couponLoading, setCouponLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [discountedPrice, setDiscountedPrice] = useState(null);
    const [couponId, setcouponId] = useState(null);

    const [ShowPayment, setShowPayment] = useState(null);

    const [SubType, setSubType] = useState(null);

    const [IsCouponApply,setIsCouponApply] = useState(null);


    const navigate = useNavigate();

    const images = [vl, pl, bl, yl];

    const LoginShow = () => {

        // window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
    };

    const token = localStorage.getItem('token');

    const handleNavigate = (slug,dilemma) => {

        if(dilemma) {
            
            if (slug && slug.trim() !== "") {
                navigate(`/dilemma/${slug}`);
            }
        }
        else
        {
            if (slug && slug.trim() !== "") {
                navigate(`/test/${slug}`);
            }
        }
      
    };

    const handleOthers = (slug) => {

        if (slug && slug.trim() !== "") {
            navigate(`/${slug}`);
        }
    };

    const AttentTest = (type) =>
    {
        setcontentType(type);

        setshowPopup(true);
    }

    
    const AttentDilemmaTest = () =>
    {
        setDilemmaPopup(true);
    }

    const TakeFreeSub = () =>
    {
        setshowFreeSub(true);
    }

    const LoginShowSub = (subids) => {

        if (subids) {
            try {
            let parsedSubIds;

            if (typeof subids === "string") {
                try {
                parsedSubIds = JSON.parse(subids);
                } catch {
                parsedSubIds = [subids];
                }
            } else if (Array.isArray(subids)) {
                parsedSubIds = subids;
            } else {
                parsedSubIds = [subids];
            }

            localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
            } catch (error) {
            console.error("Failed to save subids to localStorage:", error);
            }
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        onLoginChange(true);
    };
       

    const handleSpecial = (slug) => {

            navigate(`/${slug}`);
    };

    const handleSub = async (subJson) => {
        try {
            setShowModal(true);

            let subIds = subJson;

            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            }

            if (!Array.isArray(subIds) || subIds.length === 0) {
            console.warn("No valid subscription IDs found:", subIds);
            return;
            }

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscriptionModal(res.data);
        } catch (err) {
            console.error("Error loading subscriptions:", err);
        }
    };

    const couponHandle = (item) => {

        setSelectedItem(item);
        setCouponCode("");
        setCouponError("");
        setDiscountedPrice("");
        setcouponId("");
        setShowCouponPopup(item?.id);
    };

    const PaymentShow = (item) => {

        setCouponError("");
        setSubTypeError("");
        setIsCouponApply("");
        setSubType("");
        setCouponCode("");

        setSelectedItem(item);

        setShowPayment(item?.id);
    }

    const validateAndPayWithCoupon = async () => {

        setCouponError("");
        setSubTypeError("");

        if(!SubType && selectedItem?.type =='monthly')
        {
            setSubTypeError("Please select either option above");
            return;
        }

        if (!couponCode) {
            setCouponError("Please enter coupon code");
            return;
        }

        try {
            setCouponLoading(true);
            setDiscountedPrice(null);

            const res = await axios.post(
                `${END_URL}/validate-coupon`,
                { code: couponCode, item_id: selectedItem?.id,sub_type:SubType },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.data.status === true) {
                
                let originalPrice = 0;

                if(SubType =='one_time' || selectedItem?.type!= 'monthly')
                {
                     originalPrice = selectedItem?.price ?? 0;
                }
                else
                {
                     originalPrice = selectedItem?.recurring_price ?? 0;
                }

                console.log(originalPrice,'originalPriceoriginalPrice',SubType);

                const discount = res.data.coupon.discount_percentage ?? 0;

               const priceAfterDiscount = parseFloat(
                    (originalPrice - (originalPrice * discount / 100)).toFixed(2)
                );

                setcouponId(res.data.coupon.id);

                setDiscountedPrice(priceAfterDiscount);

            } else {
                setCouponError(res.data.message || "Invalid coupon code");
            }

        } catch (err) {
            console.error("Coupon validation failed", err);
            // setCouponError("Coupon validation failed");
            setCouponError(err?.response?.data?.message || "Invalid coupon code");
        } finally {
            setCouponLoading(false);
        }
    };

    // const payWithCoupon = () => {
        
    //     if (!discountedPrice) return;

    //     const payload = {
    //         ...selectedItem,
    //         coupon_id: couponId,
    //     };

    //     setShowCouponPopup(null);
    //     HandlePayment(payload);
    // };

    const payWithCoupon = async () => {
        
        if (discountedPrice === null) return;

        if (parseFloat(discountedPrice) === 0) {

            try {
                setButtonLoad(selectedItem.id);

                const res = await axios.post(
                    `${END_URL}/free-payment`,
                    {
                        item_id: selectedItem.id,
                        coupon_id: couponId,
                        sub_type: SubType
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setButtonLoad(null);

                if (res.data.status === true) {

                    window.location.href = res.data.redirect_url;

                } else {
                    alert("Something went wrong");
                }

            } catch (err) {
                console.error(err);
                setButtonLoad(null);
            }

            return;
        }

        const payload = {
            ...selectedItem,
            coupon_id: couponId,
        };

        setShowCouponPopup(null);
        HandlePayment(payload);
    };


    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setSubTypeError("");

                if(!SubType && item.type === 'monthly')
                {
                    setSubTypeError("Please select either option above");
                    return;
                }

                setButtonLoad(item.id);

                const pay_url = item.type === 'monthly' && SubType=='recurring' ? `paypal-payment` : `test-payment`;

                const response = await fetch(`${END_URL}/${pay_url}`, {
        
                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');

                if (data.payment) {

                    setButtonLoad(null);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(null);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };

    const [showDropdown, setShowDropdown] = useState(null); 
    const dropdownRef = useRef(null);

        useEffect(() => {
        function handleClickOutside(event) {
            if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
            ) {
            setShowDropdown(null); 
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const all_user_access = userdetail?.user_all_access == '1' ? true : false;



    const totalcount = Subcription?.data?.length || 0;


const subscriptionAltTexts = [
  "Personality quiz plans – The First Peek Pack unlocks full test results, eBook, and self-growth map for $0.01.",
  "The Monthly Peek Pass is a Personality quiz plan which gives full test access, quizzes, eBook, and growth tools for $12.97.",
  "Personality quiz plans: The Power Peek Plan offers full-year access to personality tests, 64 eBooks, and self-growth tools for $99.97.",
  "The Peek Unlimited Quiz Vault offers unlimited specialty quizzes, weekly new releases, and deep self-discovery for $0.04.",
  "Explore fun and insightful tests that reveal hidden traits and spark self-discovery with the best Personality quiz plans.",
  "Discover your deeper self with a 32-question Archetype quiz for growth and insight at just $2.97."
];

const getSubscriptionAltText = (index) => {
  if (totalcount === 2) {
    return index === 0
      ? "Personality Peek reveals hidden personality traits, inner conflicts and archetypes for deeper understanding."
      : "Uncover Hidden Personality Traits with Fun Quizzes";
  }

  return subscriptionAltTexts[index] || "Personality quiz subscription plan";
};


    return (

        <div className="subs-main">
            
            <div className="subs-sub-main">

                 {!showPopup && !showFreeSub && !DilemmaPopup && (

                    <div className="row1 subs-title">

                        <div className="subs-header" dangerouslySetInnerHTML={{ __html: Subcription?.sub_content }}>

                        </div>

                    </div>
                 )}

                <div className={subs ? 'row gy-4 subs-card-row subs-two' : 'row gy-4 subs-card-row'}>

                    { (!showFreeSub || !free_popup) && (
                        
                        <div className="col-12 col-sm-12 col-md-12" >


                            {Subcription && (

                                Subcription?.data?.map((item, index) => {


                                const canEnter = (
                                                (
                                                    (item.user_have_month &&
                                                        (item.month_sub_highest_id == item.id || item.month != 12)
                                                    ) ||
                                                    all_user_access ||
                                                    (userdetail?.deep_sub && item?.plan_type == 'deep_drive') ||
                                                    (item.plan_type == 'zoom' && userdetail?.zoom)
                                                )
                                                && force_to_disable
                                            );

                                            const isActive = (
                                            (item.month_sub_highest &&
                                                ((item.month_sub_highest_id == item.id && item.month != 12) || item.month == 12)
                                            ) ||
                                            (item.type === 'one_time' && item.month_sub_default) ||
                                            all_user_access ||
                                            (userdetail?.deep_sub && item?.plan_type == 'deep_drive') ||
                                            (item.plan_type == 'zoom' && userdetail?.zoom)
                                            );

                                            const subClass = canEnter
                                            ? (isActive ? 'sub-yes' : 'sub-grey')
                                            : 'sub-no';

                                    return (

                                    <div 
                                        // className={`row content-row ${ (item.user_have_month && ( (item.month_sub_highest_id == item.id || item.month !=12) )  ) || all_user_access || (userdetail?.deep_sub && item?.plan_type=='deep_drive' ) || (item.plan_type =='zoom' && userdetail?.zoom ) ? ((item.month_sub_highest && ( (item.month_sub_highest_id == item.id && item.month !=12) || item.month==12 ) ) || (item.type==='one_time' && item.month_sub_default) || all_user_access || (userdetail?.deep_sub && item?.plan_type=='deep_drive' ) || (item.plan_type =='zoom' && userdetail?.zoom )  ? 'sub-yes' : 'sub-grey') : 'sub-no'}`}

                                        className={`row content-row ${subClass}`}
                                        key={index} style={{
                                        backgroundImage: `url(${images[index % images.length]})`, backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover'
                                    }}>

                                        <div className={subs ? 'sub-for-large-none-col-md-3' : 'col-md-3'}>
                                            <div className="subs-right ">
                                                <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                                            </div>
                                        </div>
                                        <div className={subs ? "sub-for-col-md-9" : 'col-md-9'}>

                                            <div className="subs-left">
                                                
                                                <div className="subs-box">

                                                        <h5 className='sub-title' dangerouslySetInnerHTML={{ __html:item.title }} />

                                                        <div className="subs-amt">

                                                            <span>${item.price ?? item.actual_price}</span>

                                                            <span style={{ display: item.have_discount === false || !item.price ? 'none' : 'inline' }} data-price={item.actual_price}>${item.actual_price}</span>

                                                        </div>

                                                        {item.image && (
                                                            <div className={subs ? "subs-right sub-for-large" : "sub-for-large-none"}>
                                                                <img
                                                                src={`${IMG_URL}/d0/${item.image}`}
                                                                alt={getSubscriptionAltText(index)}

                                                                />
                                                            </div>
                                                        )}

                                                </div>
                                    
                                                <div  className={subs ? 'sub-for-content' : "" } dangerouslySetInnerHTML={{ __html: item.description }} />

                                                {token ? (
                                                    (
                                                        (
                                                            !(
                                                                (
                                                                    (item.user_have_month &&
                                                                        (
                                                                            item.month_sub_highest_id == item.id ||
                                                                            item.month != 12
                                                                        )
                                                                    )
                                                                    || all_user_access
                                                                    || (userdetail?.deep_sub && item.plan_type === 'deep_drive')
                                                                    || (item.plan_type === 'zoom' && userdetail?.zoom)
                                                                )
                                                                && force_to_disable
                                                            )

                                                        ) ? (

                                                            item.dont_allow_subscription !=0 ? (

                                                                item.special_link ? (

                                                                    <button className='test1' onClick={() => handleSpecial(item?.special_link)}>
                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                                        <span>
                                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                        </span>
                                                                    </button>
                                                                ):(

                                                                    <button className='test2'
                                                                    
                                                                    onClick={
                                                                                    () => handleSub(item?.add_sub)
                                                                                }
                                                                    
                                                                    >
                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                                        <span>
                                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                        </span>
                                                                    </button>
                                                                )
                                                            ):
                                                            (
                                                                item.type === 'other' ? (

                                                                    FreeTestSub ? (

                                                                            FreeTestAttend ? (
                                                                                <div className='sub-coupon'>
                                                                                    
                                                                                    <button className='test3' onClick={() => PaymentShow(item)}>

                                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> <FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 

                                                                                    </button>

                                                                                </div>
                                                                            ):
                                                                            (
                                                                                <button className='test4' onClick={() =>AttentTest(item?.plan_type) } >

                                                                                    {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                                </button>
                                                                            )
                                                                    ):
                                                                    (
                                                                        <button className='test5' onClick={() =>TakeFreeSub() } >

                                                                            {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                        </button>
                                                                    )
                                                                ) :
                                                                (
                                                                    
                                                                        item.test_type=='dilemma' ? (

                                                                            FreeTestAttend ? (

                                                                                    <div className='sub-coupon'>

                                                                                        <button className='test6' onClick={() => PaymentShow(item)}>
                                                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> <FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 
                                                                                            </button>

                                                                                    </div>
                                                                                ):
                                                                                (
                                                                                    <button className='test13' onClick={() =>AttentDilemmaTest() } >

                                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                                    </button>
                                                                                )
                                                                        ):(

                                                                            <div className='sub-coupon'>

                                                                                <button className='test6' onClick={() => PaymentShow(item)}>
                                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> <FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 
                                                                                    </button>

                                                                            </div>

                                                                        )
                                                                )
                                                            )

                                                        ) : (
                                                                item.test_multiple ? (

                                                                    item?.special_link ? (
                                            
                                                                    <button className='test7' onClick={() => handleSpecial(item?.special_link)}>
                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button}
                                                                        <span>
                                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                        </span>
                                                                    </button>

                                                                ) : (

                                                                    <button className='test8' ref={showDropdown === index ? dropdownRef : null} onClick={() => setShowDropdown(showDropdown === index ? null : index)} >
                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                                        <span>
                                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                        </span>

                                                                        {showDropdown === index && (
                                                                            <div className="dropdown navDrope">
                                                                                <div id="test-drop" className="dropdown-content show">
                                                                                {item.test_disable?.map((test, idx) => (
                                                                                    <a 
                                                                                    key={idx} 
                                                                                    href="#" 
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        setShowDropdown(null);
                                                                                        handleNavigate(test.slug,test.dilemma);
                                                                                    }}
                                                                                    >
                                                                                    {test.name}
                                                                                    </a>
                                                                                ))}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                    </button>
                                                                )
                                                                    
                                                                ) :
                                                                (
                                                                    item?.special_link ? (
                                                    
                                                                        <button className='test9' onClick={() => handleSpecial(item?.special_link)}>
                                                                            {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                                            <span>
                                                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                            </span>
                                                                        </button>

                                                                    ) : (

                                                                        item.type === 'other' ? (

                                        
                                                                                (FreeTestSub || all_user_access) ? (

                                                                                        FreeTestAttend && FreeTestSub ? (

                                                                                            <button className='test10' onClick={() => handleOthers(item.test_disable?.slug)} >

                                                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button}   <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 

                                                                                            </button>
                                                                                        ):
                                                                                        (
                                                                                            <button className='test11' onClick={() =>AttentTest(item?.plan_type) } >

                                                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                                            </button>
                                                                                        )
                                                                                ):
                                                                                (
                                                                                    <button className='test18' onClick={() =>TakeFreeSub() } >

                                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                                    </button>
                                                                                )
                                                                        ):
                                                                        (
                                                                            item.test_type=='dilemma' ? (

                                                                                    FreeTestAttend ? (

                                                                                            <button className='test12' onClick={() => handleNavigate(item.test_disable?.slug,item.test_disable?.dilemma)} >

                                                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button}   <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 

                                                                                            </button>
                                                                                        ):
                                                                                        (
                                                                                            <button className='test13' onClick={() =>AttentDilemmaTest() } >

                                                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />} 
                                                                                            </button>
                                                                                        )
                                                                                ):(

                                                                                    <button className='test12' onClick={() => handleNavigate(item.test_disable?.slug,item.test_disable?.dilemma)} >

                                                                                        {subClass === 'sub-no' ? item.heading : item.payment_done_button}   <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span> 

                                                                                    </button>

                                                                                )

                                                                        )
                                                                    )
                                                                )
                                                        )
                                                    )
                                                ) : (

                                                item.dont_allow_subscription ==1 ? (
                                                    
                                                item.special_link ? (
                                                
                                                        <button className='test14' onClick={() => handleSpecial(item?.special_link)}>
                                                            {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                            <span>
                                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                            </span>
                                                        </button>
                                                        ):(

                                                        <button className='test15'
                                                        
                                                            onClick={
                                                                        () => handleSub(item?.add_sub)
                                                                    }
                                                        
                                                        >
                                                            {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                            <span>
                                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                            </span>
                                                        </button>
                                                        )

                                                    ) : (


                                                        <div className='sub-coupon'>
                                                            <button className='test16' onClick={ ()=>LoginShowSub(item?.add_sub) }>
                                                                {subClass === 'sub-no' ? item.heading : item.payment_done_button} 
                                                                <span>
                                                                    <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                </span>
                                                            </button>

                                                
                                                        </div>
                                                    )
                                                )}

                                                {ShowPayment == item?.id && (

                                                    <div className="newdashpop-overlay subs-cognit-modal1 subscr-page-mdl coupen-modal-sub recurring-new-modal">

                                                        <div className="newdashpop-inner">
                                                            <div className="newdashpop-container sub-no">

                                                                <button 
                                                                    className="newdashpop-close"
                                                                    onClick={() => setShowPayment(null)}
                                                                >
                                                                    &times;
                                                                </button>

                                                                <div className="conent-pop subs-left">

                                                                    <h4 dangerouslySetInnerHTML={{ __html:item.title }}/>

                                                                    <div className="coupen-field check-new-btn" >


                                                                        {item?.type=='monthly' && (

                                                                            <div className='checkbox-outer'> 

                                                                                <div className='checkbox-buttons'>

                                                                                    <label for={`${item?.id}-onetime`} >{Subcription?.sub_data?.one_time_check_box}  <span className='onetime-monthly'>($ {item.price ?? item.actual_price})</span></label>
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="sub_type"
                                                                                        id={`${item?.id}-onetime`}
                                                                                        className="form-control"
                                                                                        value="one_time"
                                                                                        onChange={(e) => setSubType(e.target.value)}
                                                                                    />

                                                                            
                                                                                
                                                                                </div>

                                                                                <div className='checkbox-buttons'>

                                                                                    <label for={`${item?.id}-recurring`} >{Subcription?.sub_data?.recurring_check_box}  <span className='recurring-monthly'>($ {item.recurring_price ?? item.actual_recurring_price})</span></label>
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="sub_type"
                                                                                        id={`${item?.id}-recurring`}
                                                                                        className="form-control mb-2"
                                                                                        value="recurring"
                                                                                        onChange={(e) => setSubType(e.target.value)}
                                                                                    />

                                                                                

                                                                                </div>

                                                                                {SubTypeError && (
                                                                                    <p style={{ color: "red", marginBottom: "10px" }}>
                                                                                        {SubTypeError}
                                                                                    </p>
                                                                                )}

                                                                            </div>
                                                                        )}

                                                                    

                                                                        <h3>{Subcription?.sub_data?.coupon_form_title}</h3>

                                                                        {item?.type !='monthly' && (

                                                                            <span className='one_time_price'>$ {item.price ?? item.actual_price}</span>
                                                                        )}

                                                                        <div className='checkbox-buttons'>

                                                                            <label for={`${item?.id}-yes`} >Yes</label>
                                                                            <input
                                                                                type="radio"
                                                                                name="coupan_type"
                                                                                id={`${item?.id}-yes`}
                                                                                className="form-control"
                                                                                value="yes"
                                                                                checked={IsCouponApply === "yes"}
                                                                                onChange={(e) => setIsCouponApply(e.target.value)}
                                                                            />

                                                                        </div>

                                                                        <div className='checkbox-buttons'>
                                                                            <label for={`${item?.id}-no`} >No</label>
                                                                            <input
                                                                                type="radio"
                                                                                name="coupan_type"
                                                                                id={`${item?.id}-no`}
                                                                                className="form-control mb-2"
                                                                                value="no"
                                                                                checked={IsCouponApply === "no"}
                                                                                onChange={(e) => setIsCouponApply(e.target.value)}
                                                                            />

                                                                        </div>

                                                                    </div>

                                                                    {IsCouponApply ==='yes' && (

                                                                        <div className='payment-submissions'>

                                                                            <input
                                                                                type="text"
                                                                                className="form-control mb-2"
                                                                                placeholder="Enter Coupon Code"
                                                                                value={couponCode}
                                                                                onChange={(e) => setCouponCode(e.target.value)}
                                                                            />

                                                                            {couponError && (
                                                                                <p style={{ color: "red", marginBottom: "10px" }}>
                                                                                    {couponError}
                                                                                </p>
                                                                            )}

                                                                            {/* <button
                                                                                className='coupon-pay-button'
                                                                                onClick={discountedPrice ? payWithCoupon : validateAndPayWithCoupon}
                                                                                disabled={couponLoading}
                                                                            >
                                                                                {couponLoading
                                                                                    ? "Validating..."
                                                                                    : discountedPrice
                                                                                    ? `Pay $${discountedPrice}`
                                                                                    : `${Subcription?.sub_data?.coupon_btn_label}`}
                                                                                <span>

                                                                                    {(!couponLoading && ButtonLoad != item.id) && <FontAwesomeIcon className="icc" icon={faArrowRight} />} {(couponLoading || ButtonLoad === item.id) && <img index={index} src={buttonloader} alt="Loading" />}

                                                                                </span>
                                                                                
                                                                            </button> */}

                                                                            <button
                                                                                className='coupon-pay-button'
                                                                                onClick={discountedPrice !== null ? payWithCoupon : validateAndPayWithCoupon}
                                                                                disabled={couponLoading}
                                                                            >
                                                                                {couponLoading
                                                                                    ? "Validating..."
                                                                                    : discountedPrice !== null
                                                                                    ? (parseFloat(discountedPrice) === 0 
                                                                                        ? "Activate Plan" 
                                                                                        : `Pay $${discountedPrice}`)
                                                                                    : `${Subcription?.sub_data?.coupon_btn_label}`}
                                                                                    
                                                                                <span>
                                                                                    {(!couponLoading && ButtonLoad != item.id) && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                                                                    {(couponLoading || ButtonLoad === item.id) && <img src={buttonloader} alt="Loading" />}
                                                                                </span>
                                                                            </button>

                                                                        </div>
                                                                    )}

                                                                    {IsCouponApply ==='no' && (

                                                                        <div className='payment-submissions'>

                                                                            <button
                                                                                className='recurring-button'
                                                                                onClick={() => HandlePayment(item)}
                                                                                disabled={ButtonLoad == item?.id}
                                                                            >
                                                                                {item.type=='monthly' ? 'Go Monthly.Buy Now' :'Buy Now' }
                                                                                <span>

                                                                                    {ButtonLoad != item.id && <FontAwesomeIcon className="icc" icon={faArrowRight} />}  {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}

                                                                                </span>
                                                                                
                                                                            </button>
                                                                        </div>
                                                                    )}

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                ) }

                                            </div>
                                        </div>

                                    </div>
                                    
                                    )
                                })

                            )}

                        </div>

                    )}


                    { (showFreeSub && free_popup) && (
                
                            <div className="conent-pop subs-left">
                                
                                <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: FreeTest?.not_have_free_test}} />

                                <button   onClick={() => HandlePayment(FreeTest?.sub)} >
                                
                                    {FreeTest?.not_have_free_test_label}

                                    <span>

                                        {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                        
                                    </span> {ButtonLoad === FreeTest?.sub?.id && <img  src={buttonloader} alt="Loading" />}
                            
                                </button>

                            </div>
                         
                    )}


                </div>


                   {showPopup && (
                
                        <div className="newdashpop-overlay subs-cognit-modal1">
                            <div className="newdashpop-inner">
                            <div className="newdashpop-container">
                                <button
                                className="newdashpop-close"
                                onClick={() => setshowPopup(false)}
                                >
                                &times;
                                </button>
    
                                <div className="conent-pop" dangerouslySetInnerHTML={{ __html: contentType =='zoom' ? FreeTest?.not_have_free_test_pms : FreeTest?.not_have_free_test }} />

                                <a
                                    className="home-slider-sun-box-a"
                                    href={`test/${FreeTest?.slug}`}
                                    rel="noopener noreferrer"
                                >
                                <span className="home-slider-sun-box-a-text">{FreeTest?.not_attend_free_test_label}</span>
                                <span className="home-slider-sun-box-a-icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                    )}

                     {DilemmaPopup && (
                
                        <div className="newdashpop-overlay subs-cognit-modal1">
                            <div className="newdashpop-inner">
                            <div className="newdashpop-container">
                                <button
                                className="newdashpop-close"
                                onClick={() => setDilemmaPopup(false)}
                                >
                                &times;
                                </button>
    
                                <div className="conent-pop" dangerouslySetInnerHTML={{ __html: FreeTest?.not_have_free_test_dilemma}} />

                                <a
                                    className="home-slider-sun-box-a"
                                    href={`test/${FreeTest?.slug}`}
                                    rel="noopener noreferrer"
                                >
                                <span className="home-slider-sun-box-a-text">{FreeTest?.not_attend_free_test_label}</span>
                                <span className="home-slider-sun-box-a-icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                    )}

                    { (showFreeSub && !free_popup) && (
                
                        <div className={`newdashpop-overlay subs-cognit-modal1 ${free_popup ? "free-popup" : ""}`}>
                            <div className="newdashpop-inner">
                                <div className="newdashpop-container  sub-no">
                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setshowFreeSub(false)}
                                        >
                                    &times;
                                    </button>
            
                                    <div className="conent-pop subs-left">
                                        
                                       <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: FreeTest?.not_have_free_test}} />

                                        <button   onClick={() => HandlePayment(FreeTest?.sub)} >
                                        
                                            {FreeTest?.not_have_free_test_label}

                                            <span>

                                                {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                                
                                            </span> {ButtonLoad === FreeTest?.sub?.id && <img  src={buttonloader} alt="Loading" />}
                                    
                                        </button>

                                    </div>
            
                                
                                </div>
                            </div>
                        </div>
                    )}


                    {ShowModal && (
                                  
                        <div className="newdashpop-overlay subs-cognit-modal1">

                            <div className="newdashpop-inner">

                                <div className="newdashpop-container">

                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setShowModal(false)}
                                        >
                                        &times;
                                    </button>

                                    <div className="conent-pop">
                                    
                                        <SubscriptionModal subs={subS} userdetail={userdetail} Subcription={subscriptionmodal} onLoginChange={onLoginChange}/>

                                    </div>

                                </div>

                            </div>

                        </div>
                    )}

                    {showInsufficientPopup && (
                                  
                        <div className="newdashpop-overlay insufficientPayment">
                        
                            <div className="newdashpop-inner">
                                <div className="newdashpop-container sub-no">

                                    <button className="newdashpop-close"
                                        onClick={() => {
                                            setShowInsufficientPopup(false);
                                            window.history.replaceState({}, "", window.location.pathname);
                                        }}
                                    >
                                        &times;
                                    </button>

                                    <div className="conent-pop subs-left">

                                        <h2>{reasonMessage}</h2>
                                        
                                        <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html:Subcription?.sub_data?.payment_failed_msg }} />
                                      
                                        <button
                                                onClick={() => {
                                                    setShowInsufficientPopup(false);
                                                    window.history.replaceState({}, "", window.location.pathname);
                                                }}
                                            >
                                            Close
                                            <span>
                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                            </span>
                                        </button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    )}


                   {paymentupdate && (

                        <div className="newdashpop-overlay insufficientPayment payment-loading">

                                <div className="newdashpop-inner">
                                    <div className="newdashpop-container sub-no">

                                        <div className="conent-pop subs-left loading-center">
                                        <h2>Payment Processing</h2>

                                        <div className="conent-pop-text">
                                            <p>Please wait, your payment is being confirmed…</p>
                                            <img src={loadimg} alt="Loading" className="payment-loader"/>
                                        </div>

                                        </div>

                                    </div>
                                </div>
                        </div>
                    )}


            </div>

        </div>
    )
}

export default Subscriptions